var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileZip = function SvgFileZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 35 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5F5",
    d: "M7.5 0A2.507 2.507 0 0 0 5 2.5v35C5 38.875 6.125 40 7.5 40h25c1.375 0 2.5-1.125 2.5-2.5V10L25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0C9DF",
    d: "M27.5 10H35L25 0v7.5c0 1.375 1.125 2.5 2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M30 32.5c0 .688-.562 1.25-1.25 1.25H1.25C.563 33.75 0 33.188 0 32.5V20c0-.687.563-1.25 1.25-1.25h27.5c.688 0 1.25.563 1.25 1.25z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Gilroy-Bold, Gilroy",
    fontSize: 10,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 30
  }, "ZIP")))));
};
export default SvgFileZip;